(function () {
  if (window.QeEyeDropsScriptLoaded) return;
  window.QeEyeDropsScriptLoaded = true;

  function initGrid(root) {
    if (!root || root.dataset.qeGridInitialized === 'true') return;
    root.dataset.qeGridInitialized = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-qe-product-card]'));
    var search = root.querySelector('[data-qe-product-search]');
    var count = root.querySelector('[data-qe-result-count]');
    var noResults = root.querySelector('[data-qe-no-results]');
    var sort = root.querySelector('[data-qe-sort]');
    var filterLists = Array.prototype.slice.call(root.querySelectorAll('[data-qe-filter-list]'));
    var selected = { concern: '', vendor: '', format: '', price: '' };

    function matchesPrice(price, range) {
      if (!range) return true;
      if (range === 'under-10') return price < 10;
      if (range === '10-15') return price >= 10 && price < 15;
      if (range === '15-up') return price >= 15;
      return true;
    }

    function applyFilters() {
      var term = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      cards.forEach(function (card) {
        var concern = card.dataset.concern || '';
        var vendor = card.dataset.vendor || '';
        var format = card.dataset.format || '';
        var price = Number(card.dataset.price || 0);
        var searchText = card.dataset.search || '';

        var show = (!term || searchText.indexOf(term) !== -1) &&
          (!selected.concern || concern.split(' ').indexOf(selected.concern) !== -1) &&
          (!selected.vendor || vendor.indexOf(selected.vendor) !== -1) &&
          (!selected.format || format === selected.format) &&
          matchesPrice(price, selected.price);

        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) {
        var singular = count.dataset.qeItemSingular || 'product';
        var plural = count.dataset.qeItemPlural || 'products';
        var hasActiveFilters = term || selected.concern || selected.vendor || selected.format || selected.price;
        var total = Number(count.dataset.qeTotalCount || visible);
        var resultTotal = hasActiveFilters ? visible : total;
        count.textContent = resultTotal + ' ' + (resultTotal === 1 ? singular : plural);
      }
      if (noResults) noResults.hidden = visible !== 0;
    }

    filterLists.forEach(function (list) {
      var group = list.dataset.qeFilterList;
      list.addEventListener('click', function (event) {
        var button = event.target.closest('[data-qe-filter]');
        if (!button) return;
        var nextValue = button.dataset.qeFilter;
        var shouldClear = selected[group] === nextValue;

        list.querySelectorAll('[data-qe-filter]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        selected[group] = shouldClear ? '' : nextValue;
        if (!shouldClear) {
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
        }
        applyFilters();
      });
    });

    if (search) search.addEventListener('input', applyFilters);

    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    var filters = root.querySelector('[data-qe-filters]');
    if (filters) {
      var mobile = window.matchMedia('(max-width: 900px)');
      if (mobile.matches) filters.removeAttribute('open');
      if (typeof mobile.addEventListener === 'function') {
        mobile.addEventListener('change', function (event) {
          if (!event.matches) filters.setAttribute('open', '');
        });
      }
    }

    applyFilters();
  }

  function initFaq(root) {
    if (!root || root.dataset.qeFaqInitialized === 'true') return;
    root.dataset.qeFaqInitialized = 'true';

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-qe-faq-tab]');
      if (!tab) return;
      var key = tab.dataset.qeFaqTab;

      root.querySelectorAll('[data-qe-faq-tab]').forEach(function (button) {
        button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
      });

      root.querySelectorAll('[data-qe-faq-panel]').forEach(function (panel) {
        var active = panel.dataset.qeFaqPanel === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-qe-grid-root]').forEach(initGrid);
    document.querySelectorAll('[data-qe-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
